import React from 'react';
import { StarIcon } from 'lucide-react';
import { trustPoints } from '../data/site';
export function TrustStrip() {
  return <section aria-label="Why customers trust East End Automotive Repair" className="w-full border-b border-black/10 bg-charcoal" data-id="element-266" data-mp="2o53yp2k0hrk9">
      <div className="mx-auto grid max-w-shell grid-cols-2 gap-px overflow-hidden bg-white/10 md:grid-cols-3 lg:grid-cols-5" data-id="element-267" data-mp="2fbh5nk76v2er">
        {trustPoints.map((point, i) => <div key={point.stat} className="flex flex-col justify-center bg-charcoal px-5 py-6 lg:px-6 lg:py-7" data-id="element-268" data-mp="2adpguz1ubwes" data-mpi={i}>
            <p className="flex items-center gap-1.5 font-display text-xl font-bold tracking-tight text-white lg:text-[22px]" data-id="element-269" data-mp="20dou134riy5u">
              {i === 0 && <StarIcon className="h-5 w-5 fill-brand text-brand" aria-hidden="true" data-id="element-270" data-mp="1wepslsi8pjj5" />}
              {point.stat}
            </p>
            <p className="mt-1.5 text-[13px] leading-snug text-chalk/60" data-id="element-271" data-mp="3qojmmgd79tzg">
              {point.label}
            </p>
          </div>)}
      </div>
    </section>;
}